import { section } from "@/neon";
import { animateTextColumnsWithImages } from "@/lib/animation";

section("text-columns-with-images", {
  onLoad() {
    this.animateTextColumnsWithImages = animateTextColumnsWithImages(
      this.container
    );
  },

  onUnload() {
    this.animateTextColumnsWithImages?.destroy();
  },
});
